<template>
	<LoginLayout>
		<div class="form-container vtd-login">
			<b-col
				class="login-form-box col-md-12 col-lg-6 order-1 order-lg-2 p-3"
			>
				<b-form
					class="login-form"
					@submit.stop.prevent="onSubmit"
				>
					<div class="vtd-card-block">
						<b-img
							src="https://cdn.trailfinders.com/7txvnzm4j4__tf_corporate-logo_white.png"
							fluid
							alt="Corporate"
							class="logo-title"
						></b-img>
						<FlashMessage />
						<b-form-group
							label-for="input-clientref"
							class="vtd-form-group"
						>
							<b-form-input
								id="input-clientref"
								v-model.trim="$v.form.clientref.$model"
								type="text"
								class="vtd-form-control vtd-form-control-lg vtd-login"
								:state="validateState('clientref')"
								placeholder="Client Number"
							/>
						</b-form-group>

						<b-form-group
							label-for="input-email"
							class="vtd-form-group"
						>
							<b-form-input
								id="input-email"
								v-model.trim="$v.form.email.$model"
								type="text"
								class="vtd-form-control vtd-form-control-lg vtd-login"
								:state="validateState('email')"
								placeholder="Email Address"
							/>
						</b-form-group>

						<b-form-group
							label-for="input-password"
							class="vtd-form-group"
						>
							<b-form-input
								id="input-password"
								v-model.trim="$v.form.password.$model"
								type="password"
								class="vtd-form-control vtd-form-control-lg vtd-login"
								:state="validateState('password')"
								placeholder="Password"
							/>
						</b-form-group>

						<b-form-checkbox
							id="checkbox-1"
							v-model="form.rememberMe"
							class="switch-box"
							switch
							size="sm"
							name="checkbox-1"
							value="true"
							unchecked-value="false"
						>
							Remember me
						</b-form-checkbox>

						<div class="vtd-footer">
							<b-button
								type="submit"
								class="vtd-btn vtd-btn-success vtd-btn-login vtd-btn-xl vtd-btn-block vtd-btn-center vtd-text-white corp-login-btn vtd-login mb-3"
							>
								Login
							</b-button>

							<b-button
								type="button"
								class="vtd-btn vtd-btn-success vtd-btn-login vtd-btn-xl vtd-btn-block vtd-btn-center vtd-text-white corp-register-btn vtd-login mb-3"
								@click="
									() => {
										openModal('RegisterRef');
									}
								"
							>
								Register
							</b-button>

							<b-button
								type="button"
								class="vtd-btn vtd-btn-success vtd-btn-login vtd-btn-xl vtd-btn-block vtd-btn-center vtd-text-white corp-reset-btn vtd-login mb-3"
								@click="
									() => {
										openModal('ResetPasswordRef');
									}
								"
							>
								Reset Password
							</b-button>
							<b-button
								class="portal-btn vtd-btn vtd-btn-xl vtd-btn-block vtd-btn-center vtd-login"
								type="button"
								@click="goToLogin"
								>Leisure Travel ViewTrail</b-button
							>
						</div>
					</div>
				</b-form>
			</b-col>
			<ResetPassword ref="ResetPasswordRef" />
			<Register ref="RegisterRef" />
		</div>
	</LoginLayout>
</template>

<script>
	import ResetPassword from "@/modules/auth/reset-password";
	import Register from "@/modules/auth/register";
	import { required, email } from "vuelidate/lib/validators";
	import LoginLayout from "@/partials/login-layout";
	import FlashMessage from "@/partials/flash-message";
	import { mapActions } from "vuex";
	export default {
		components: {
			LoginLayout,
			FlashMessage,
			ResetPassword,
			Register,
		},
		data() {
			return {
				version: process.env.PACKAGE_VERSION || "0",
				form: {
					clientref: "",
					email: "",
					password: "",
					corporate: true,
					rememberMe: false,
				},
			};
		},
		validations: {
			form: {
				clientref: {
					required,
				},
				email: {
					required,
					email,
				},
				password: {
					required,
				},
			},
		},
		methods: {
			validateState(name) {
				const { $dirty, $error } = this.$v.form[name];
				return $dirty ? !$error : null;
			},
			openModal(item) {
				this.$refs[item].showModal();
			},
			...mapActions({
				login: "auth/loginCorporateAction",
			}),
			goToLogin() {
				this.$router.push("/login");
			},
			async onSubmit() {
				this.$v.form.$touch();
				if (this.$v.form.$anyError) {
					return;
				}
				const res = await this.login(this.form);
				if (res) {
					this.$router.push("/landing-corp");
				}
			},
		},
	};
</script>

<style scoped>
	@import "./styles.scss";
</style>
